/*
 * Copyright 2019 NEM
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Catapult REST API Reference
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 0.7.15
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */


import ApiClient from '../ApiClient';


/**
* Enum class AccountPropertyTypeEnum.
* @enum {}
* @readonly
*/
export default class AccountPropertyTypeEnum {
    
        /**
         * value: 1
         * @const
         */
        1 = 1;

    
        /**
         * value: 2
         * @const
         */
        2 = 2;

    
        /**
         * value: 4
         * @const
         */
        4 = 4;

    
        /**
         * value: 5
         * @const
         */
        5 = 5;

    
        /**
         * value: 129
         * @const
         */
        129 = 129;

    
        /**
         * value: 130
         * @const
         */
        130 = 130;

    
        /**
         * value: 132
         * @const
         */
        132 = 132;

    

    /**
    * Returns a <code>AccountPropertyTypeEnum</code> enum value from a Javascript object name.
    * @param {Object} data The plain JavaScript object containing the name of the enum value.
    * @return {module:model/AccountPropertyTypeEnum} The enum <code>AccountPropertyTypeEnum</code> value.
    */
    static constructFromObject(object) {
        return object;
    }
}


